import React from "react";
import PropTypes from "prop-types";
import { DateTimePicker, TimePicker } from "@material-ui/pickers";
import DateRangeWrapper from "components/DateRangeWrapper";
import {useTranslation} from "react-i18next";

export default function DateTypeFilter(props) {
	const {t} = useTranslation();
	const { columnDef, onFilterChanged } = props;
	const onDateInputChange = date =>
		onFilterChanged(columnDef.tableData.id, date);
	let dateInputElement = null;

	if (columnDef.type === "date") {
		dateInputElement = (
			<DateRangeWrapper
				label={t("filter.date")}
				value={columnDef.filterValue || []}
				onChange={onDateInputChange}
				clearable
			/>
		);
	} else if (columnDef.type === "datetime") {
		dateInputElement = (
			<DateTimePicker
				label={t("filter.date")}
				value={columnDef.filterValue || null}
				onChange={onDateInputChange}
				clearable
			/>
		);
	} else if (columnDef.type === "time") {
		dateInputElement = (
			<TimePicker
				label={t("filter.date")}
				value={columnDef.filterValue || null}
				onChange={onDateInputChange}
				clearable
			/>
		);
	}

	return dateInputElement;
}

DateTypeFilter.propTypes = {
	columnDef: PropTypes.object.isRequired,
	onFilterChanged: PropTypes.func.isRequired
};
